export const GIPHY_API_KEY = "BhwRjWwYPLy6Xm7RM4XKwrE10IoyIjWb";
